module.exports = __webpack_public_path__ + "img/PriceSelectOn.d3070b30.png";